import { messageAutomationPreferencesConstants } from '@constants';

const initialState = {
  isFetchingUserPreferences: false,
  userPreferences: [],
  isUpdatingUserPreference: false,
  error: null,
};

export default function messageAutomationPreferences(state = initialState, action) {
  switch (action.type) {
    case messageAutomationPreferencesConstants.GET_USER_PREFERENCES_STARTED:
      return { ...state, isFetchingUserPreferences: true };
    case messageAutomationPreferencesConstants.GET_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        isFetchingUserPreferences: false,
        userPreferences: action.preferences || [],
      };
    case messageAutomationPreferencesConstants.GET_USER_PREFERENCES_FAILURE:
      return {
        ...state,
        isFetchingUserPreferences: false,
        error: action.message || 'Failed to fetch preferences',
      };

    case messageAutomationPreferencesConstants.UPDATE_USER_PREFERENCE_STARTED:
      return { ...state, isUpdatingUserPreference: true };
    case messageAutomationPreferencesConstants.UPDATE_USER_PREFERENCE_SUCCESS: {
      const updatedPref = action.preference;
      const updatedId = updatedPref?.messageAutomation?.id;
      return {
        ...state,
        isUpdatingUserPreference: false,
        userPreferences: state.userPreferences.map((pref) =>
          pref.messageAutomation?.id === updatedId ? { ...pref, ...updatedPref } : pref
        ),
      };
    }
    case messageAutomationPreferencesConstants.UPDATE_USER_PREFERENCE_FAILURE:
      return {
        ...state,
        isUpdatingUserPreference: false,
        error: action.message || 'Failed to update preference',
      };

    default:
      return state;
  }
}
